import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NewsView } from '../../model/models';
import { IonIcon } from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import { Link } from 'react-router-dom';
import { NewsListSimple } from '../news/NewsListSimple';
import { NewsItemSimple } from '../news/NewsItemSimple';
import { NewsGrid } from '../news/NewsGrid';

interface NewsListProps {
  newsList: NewsView[];
}

export const NewsTab: React.FC<NewsListProps> = ({ newsList }) => {
  return (
    <div className="w-full text-left mt-2 px-2 md:mt-5">
      <Link
        className="hidden text-sm items-center font-bold text-primary mb-8 md:flex"
        to="/house"
      >
        <IonIcon className="text-primary mr-2" icon={chevronBackOutline} />
        <FormattedMessage id="Go back" />
      </Link>
      <h1 className="font-semibold mb-8 text-xl">
        <FormattedMessage id="All news" /> <br />
        <span className="border-after inline-block">
          <FormattedMessage id="of the house" />
        </span>
      </h1>
      <NewsListSimple
        news={newsList}
        baseUrl="/house/news"
        itemRenderer={NewsItemSimple}
      />
    </div>
  );
};

export const NewsTabDesktop: React.FC<NewsListProps> = ({ newsList }) => {
  return (
    <div className="w-full text-left mt-2 bg-white bg-opacity-60 p-7 border-0 rounded-3xl">
      <div className="flex flex-row justify-between items-center mb-8 ">
        <h1 className="font-semibold text-xl inline-block m-0">
          <FormattedMessage id="All news" /> <br />
        </h1>
        <Link to="/house/news" className="text-primary font-bold text-xs m-0">
          <FormattedMessage id="See more" />
        </Link>
      </div>
      <NewsGrid
        news={newsList.slice(0, 3)}
        baseUrl="/house/news"
        cols="1"
        itemRenderer={NewsItemSimple}
        checklist={null}
      />
    </div>
  );
};
